var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFortunaLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 251.2,
    height: 66.8,
    viewBox: "0 0 251.2 66.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fortuna-logo1",
    transform: "translate(-133.2 -229)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_35_",
    width: 251.2,
    height: 66.8,
    transform: "translate(133.2 229)",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    d: "M153.6,275.3V249.5h20.5v6.4H160.3v3.5H171v6.4H160.3v9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    d: "M217.2,275.3V249.5h13.7a8.459,8.459,0,0,1,8.7,8.7,8.233,8.233,0,0,1-5.1,7.7c.6,1,5,8.5,5.6,9.4h-8.2c-.5-.8-4.3-7.5-4.8-8.5h-3.4v8.5Zm6.5-14.8h6.6a2.493,2.493,0,0,0,2.7-2.3,2.45,2.45,0,0,0-2.7-2.4h-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    d: "M253.8,275.3V255.9h-6.3v-6.4h19.2v6.4h-6.3v19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    d: "M276.4,249.5H283V266a3.5,3.5,0,0,0,7,0V249.6h6.5v16a10.053,10.053,0,1,1-20.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    d: "M309,275.3V249c1,.9,12.8,11.5,14.1,12.6V249.5h6.5v26.3c-1.3-1.1-13-11.6-14.1-12.6v12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    d: "M345.2,275.3h-7c.2-.5,9.1-25.3,9.3-25.8h6.7c.2.4,9.5,25.2,9.7,25.8h-7.1c-.2-.5-1.4-3.9-1.6-4.3h-8.5c-.1.3-1.4,4-1.5,4.3m5.6-16.2c-.2.5-1.8,5.2-1.9,5.5h3.9c-.1-.3-1.9-5.1-2-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    d: "M208.2,262.3a13.7,13.7,0,1,1-13.7-13.7,13.721,13.721,0,0,1,13.7,13.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    d: "M201.7,262.4a7.1,7.1,0,1,1-7.1-7.1,7.127,7.127,0,0,1,7.1,7.1m6.5-.1A13.7,13.7,0,1,0,194.5,276a13.721,13.721,0,0,0,13.7-13.7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortunaLogo1);
export default __webpack_public_path__ + "static/media/Fortuna-logo1.fe89e9c0641702df3783e254b2310e13.svg";
export { ForwardRef as ReactComponent };